// 需要 jquery   slick
if (!customElements.get("scroll-shop-point")) {
    customElements.define(
      "scroll-shop-point",
      class ScrollShopPoint extends HTMLElement {
        constructor(){
          super();
          this.scroll_shop_point_list = $(this).find('.scroll_shop_point_list');
          this.initScrollShopPoint();
        }

        initScrollShopPoint(){
          const that = this;
          setTimeout(function(){
            that.scroll_shop_point_list.slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              autoplay: false,
              arrows: false,
              rows:0,
              responsive:[
                {
                  breakpoint: 768,
                  settings: {
                    autoplay: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true
                  }
                }
              ]
            }).on('setPosition', function (event, slick) {
                slick.$slides.css('height', slick.$slideTrack.height() + 'px');
            });
          },0)
        }
      }
    )
}